import { render, staticRenderFns } from "./capture.vue?vue&type=template&id=04976046&scoped=true&"
import script from "./capture.vue?vue&type=script&lang=ts&"
export * from "./capture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04976046",
  null
  
)

export default component.exports